import z from 'zod';
import { InvalidStripeProductIdFormatError } from '../errors/invalid-stripe-product-id-format.error';
const STRIPE_PRODUCT_ID_PREFIX = 'prod_';
const STRIPE_PRODUCT_ID_MIN_LENGTH = 10;
const STRIPE_PRODUCT_ID_MAX_LENGTH = 128;
export const stripeCustomerIdValue = z
    .string()
    .trim()
    .min(1)
    .brand('StripeCustomerId');
export const createStripeCustomerId = (value) => stripeCustomerIdValue.parse(value);
export const isStripeCustomerId = (value) => stripeCustomerIdValue.safeParse(value).success;
const STRIPE_PRICE_ID_PREFIX = 'price_';
const STRIPE_PRICE_ID_MIN_LENGTH = 10;
const STRIPE_PRICE_ID_MAX_LENGTH = 128;
export const stripePriceIdValue = z
    .string()
    .trim()
    .refine(isValidStripeProductPriceIdFormat, {
    message: 'Invalid stripe price id format',
})
    .brand('StripePriceId');
export const createStripePriceId = (value) => stripePriceIdValue.parse(value);
export const isStripePriceId = (value) => stripePriceIdValue.safeParse(value).success;
export const stripeProductPriceIdValue = stripePriceIdValue.brand('StripeProductPriceId');
export const createStripeProductPriceId = (value) => stripeProductPriceIdValue.parse(value);
export const isStripeProductPriceId = (value) => stripeProductPriceIdValue.safeParse(value).success;
export const stripeProductIdValue = z
    .string()
    .trim()
    .refine(isValidStripeProductIdFormat, {
    message: 'Invalid stripe product id format',
})
    .brand('StripeProductId');
export const createStripeProductId = (value) => {
    if (!isValidStripeProductIdFormat(String(value))) {
        throw new InvalidStripeProductIdFormatError();
    }
    return stripeProductIdValue.parse(value);
};
export const isStripeProductId = (value) => stripeProductIdValue.safeParse(value).success;
export const stripeSubscriptionIdValue = z
    .string()
    .trim()
    .min(1)
    .brand('StripeSubscriptionId');
export const createStripeSubscriptionId = (value) => stripeSubscriptionIdValue.parse(value);
export const isStripeSubscriptionId = (value) => stripeSubscriptionIdValue.safeParse(value).success;
export const subscriptionPlanIdValue = z
    .string()
    .trim()
    .min(1)
    .brand('SubscriptionPlanId');
export const createSubscriptionPlanId = (value) => subscriptionPlanIdValue.parse(value);
export const isSubscriptionPlanId = (value) => subscriptionPlanIdValue.safeParse(value).success;
export function isValidStripeProductIdFormat(value) {
    const normalizedValue = value.trim();
    return normalizedValue.startsWith(STRIPE_PRODUCT_ID_PREFIX)
        && normalizedValue.length >= STRIPE_PRODUCT_ID_MIN_LENGTH
        && normalizedValue.length <= STRIPE_PRODUCT_ID_MAX_LENGTH
        && /^prod_[\dA-Za-z]+$/.test(normalizedValue);
}
export function isValidStripeProductPriceIdFormat(value) {
    const normalizedValue = value.trim();
    return normalizedValue.startsWith(STRIPE_PRICE_ID_PREFIX)
        && normalizedValue.length >= STRIPE_PRICE_ID_MIN_LENGTH
        && normalizedValue.length <= STRIPE_PRICE_ID_MAX_LENGTH
        && /^price_[\dA-Za-z]+$/.test(normalizedValue);
}
const STRIPE_PRICE_LOOKUP_KEY_MIN_LENGTH = 3;
const STRIPE_PRICE_LOOKUP_KEY_MAX_LENGTH = 128;
export const stripePriceLookupKeyValue = z
    .string()
    .trim()
    .refine(isValidStripePriceLookupKeyFormat, {
    message: 'Invalid stripe price lookup key format',
})
    .brand('StripePriceLookupKey');
export const createStripePriceLookupKey = (value) => stripePriceLookupKeyValue.parse(value);
export const isStripePriceLookupKey = (value) => stripePriceLookupKeyValue.safeParse(value).success;
export function isValidStripePriceLookupKeyFormat(value) {
    const normalizedValue = value.trim();
    return normalizedValue.length >= STRIPE_PRICE_LOOKUP_KEY_MIN_LENGTH
        && normalizedValue.length <= STRIPE_PRICE_LOOKUP_KEY_MAX_LENGTH
        && /^[\w+-]+$/.test(normalizedValue);
}
const STRIPE_PAYMENT_METHOD_ID_PREFIX = 'pm_';
/**
 * Modern Stripe PaymentMethod ids only (`pm_…`).
 * Legacy Sources (`src_…`) are not reusable for direct charges.
 */
export function isStripePaymentMethodId(value) {
    if (typeof value !== 'string') {
        return false;
    }
    const normalizedValue = value.trim();
    return normalizedValue.startsWith(STRIPE_PAYMENT_METHOD_ID_PREFIX)
        && normalizedValue.length > STRIPE_PAYMENT_METHOD_ID_PREFIX.length;
}
//# sourceMappingURL=stripe-ids.js.map